import { RelationshipModel } from '../Relationships/RelationshipModel'

export class StoredCommandSearchOptions {

    c: string = '';

    r: RelationshipModel = new RelationshipModel();

    li: string = '';

    l: number = 100;
}